export default __webpack_public_path__ + "02538c8e9d95469998dbb9104b27326a.svg";